import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enUS from './resources/en-us';
import esMX from './resources/es-mx';

const resources = {
    en: enUS,
    es: esMX,
};

const initi18n = (brandedAppName) => {
    i18n
        .use(initReactI18next) // passes i18n down to react-i18next
        .init({
            compatibilityJSON: 'v3',
            resources,
            fallbackLng: "en-us", // use en-us if detected lng is not available
            debug: process.env.NODE_ENV == 'development', // shows if we are missing any translation key / values,
            interpolation: {
                defaultVariables: {
                    brandedAppName,
                }
            }
        });
}

initi18n("Amira Learning");


export default i18n;
export {
    initi18n
}